var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"error-modal","visible":_vm.visible,"title":"Error","ok-only":""},on:{"hidden":_vm.hide}},[_c('p',[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }